'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = FormLabel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('FormLabel', function (theme) {
  return {
    root: {
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      color: theme.palette.text.primary
    },
    asterisk: {
      color: theme.palette.text.error
    },
    labelOuter: {
      display: 'inline',
      maxWidth: '100%'
    },
    labelInner: {
      display: 'inline'
    },
    labelEllipsis: theme.mixins.truncate()
  };
});

function FormLabel(props, context) {
  var children = props.children,
      classNameProp = props.className,
      ellipsize = props.ellipsize,
      errorProp = props.error,
      requiredProp = props.required,
      focusedProp = props.focused,
      requiredAsterisk = props.requiredAsterisk,
      other = _objectWithoutProperties(props, ['children', 'className', 'ellipsize', 'error', 'required', 'focused', 'requiredAsterisk']);

  var muiFormControl = context.muiFormControl,
      styleManager = context.styleManager;

  var classes = styleManager.render(styleSheet);

  var required = requiredProp;
  var focused = focusedProp;
  var error = errorProp;

  if (muiFormControl) {
    if (typeof required === 'undefined') {
      required = muiFormControl.required;
    }
    if (typeof focused === 'undefined') {
      focused = muiFormControl.focused;
    }
    if (typeof error === 'undefined') {
      error = muiFormControl.error;
    }
  }

  var className = (0, _classnames2['default'])(classes.root, classNameProp);

  var labelClassName = (0, _classnames2['default'])(classes.labelInner, _defineProperty({}, classes.labelEllipsis, ellipsize));

  return _react2['default'].createElement(
    'label',
    _extends({ htmlFor: 'Form', className: className }, other),
    _react2['default'].createElement(
      'div',
      { className: classes.labelOuter },
      _react2['default'].createElement(
        'div',
        { className: labelClassName },
        children
      )
    ),
    (required || requiredAsterisk) && _react2['default'].createElement(
      'span',
      { className: classes.asterisk, 'data-mui-test': 'FormLabelAsterisk' },
      '\u2009*'
    )
  );
}

FormLabel.propTypes = {
  /**
   * The content of the component.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, the label will trunacte with an ellipsis.
   */
  ellipsize: _PropTypes2['default'].bool,
  /**
   * Whether the label should be displayed in an error state.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If true, the input of this label is focused (used by FormGroup components).
   */
  focused: _PropTypes2['default'].bool,
  /**
   * If true, the label will indicate that the input is required.
   */
  required: _PropTypes2['default'].bool,
  /**
   * If true, the label will display an asterisk as if the input is required.
   */
  requiredAsterisk: _PropTypes2['default'].bool,
  /**
   * If true, the label will shrink above the control
   */
  shrink: _PropTypes2['default'].bool
};

FormLabel.defaultProps = {
  ellipsize: false
};

FormLabel.contextTypes = {
  muiFormControl: _PropTypes2['default'].object,
  styleManager: _PropTypes2['default'].styleManager.isRequired
};

FormLabel.displayName = 'FormLabel';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Form/FormLabel.js
// module id = 1636
// module chunks = 32